module.exports = __webpack_public_path__ + "static/img/5.7981c32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gallery/5.jpg
// module id = 423
// module chunks = 1